import { ModelInputs } from "../features/projects/domain/types";

export function parseNumericInputs(formData: ModelInputs): ModelInputs {
    const numericKeys: (keyof ModelInputs)[] = [
        "latitude",
        "longitude",
        "nameplate_capacity",
        "poi_limit",
        "project_additional_load",
        "ppa_percentage",
        "ppa_capacity",
        "battery_capacity_mwh",
        "battery_charge_rate_mw",
        "battery_discharge_rate_mw",
        "battery_round_trip_eff",
        "battery_soc_min",
    ];

    const parsed: ModelInputs = { ...formData };
    numericKeys.forEach(k => {
        (parsed as any)[k] = Number((parsed as any)[k]);
    });
    // Blank lifetime means "use the default": send null (clears it), never "" or 0.
    const lifetime = (parsed as any).project_lifetime_years;
    (parsed as any).project_lifetime_years =
        lifetime === "" || lifetime === null || lifetime === undefined ? null : Number(lifetime);

    return parsed;
}